module.exports = __webpack_public_path__ + "img/HomePage.5d9e24e6.png";